import { render, staticRenderFns } from "./UniteColoniesOrRemoveQueen2.vue?vue&type=template&id=3d6c6b72&scoped=true&"
import script from "./UniteColoniesOrRemoveQueen2.vue?vue&type=script&lang=js&"
export * from "./UniteColoniesOrRemoveQueen2.vue?vue&type=script&lang=js&"
import style0 from "./UniteColoniesOrRemoveQueen2.vue?vue&type=style&index=0&id=3d6c6b72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d6c6b72",
  null
  
)

export default component.exports